export default {
    air_accident: {
        name: "Air Accident",
        url: "nfpa_emergency_incidents_symbology/air_accident",
    },
    air_hijacking: {
        name: "Air Hijacking",
        url: "nfpa_emergency_incidents_symbology/air_hijacking",
    },
    air_incident: {
        name: "Air Incident",
        url: "nfpa_emergency_incidents_symbology/air_incident",
    },
    bomb: {
        name: "Bomb",
        url: "nfpa_emergency_incidents_symbology/bomb",
    },
    bomb_explosion: {
        name: "Bomb Explosion",
        url: "nfpa_emergency_incidents_symbology/bomb_explosion",
    },
    bomb_threat: {
        name: "Bomb Threat",
        url: "nfpa_emergency_incidents_symbology/bomb_threat",
    },
    chemical_agent: {
        name: "Chemical Agent",
        url: "nfpa_emergency_incidents_symbology/chemical_agent",
    },
    civil_demonstrations: {
        name: "Civil Demonstrations",
        url: "nfpa_emergency_incidents_symbology/civil_demonstrations",
    },
    civil_displaced_population: {
        name: "Civil Displaced Population",
        url: "nfpa_emergency_incidents_symbology/civil_displaced_population",
    },
    civil_disturbance_incident: {
        name: "Civil Disturbance Incident",
        url: "nfpa_emergency_incidents_symbology/civil_disturbance_incident",
    },
    civil_rioting: {
        name: "Civil Rioting",
        url: "nfpa_emergency_incidents_symbology/civil_rioting",
    },
    corrosive_material: {
        name: "Corrosive Material",
        url: "nfpa_emergency_incidents_symbology/corrosive_material",
    },
    criminal_activity_incident: {
        name: "Criminal Activity Incident",
        url: "nfpa_emergency_incidents_symbology/criminal_activity_incident",
    },
    dangerous_when_wet: {
        name: "Dangerous When Wet",
        url: "nfpa_emergency_incidents_symbology/dangerous_when_wet",
    },
    explosive: {
        name: "Explosive",
        url: "nfpa_emergency_incidents_symbology/explosive",
    },
    fire_incident: {
        name: "Fire Incident",
        url: "nfpa_emergency_incidents_symbology/fire_incident",
    },
    flammable_gas: {
        name: "Flammable Gas",
        url: "nfpa_emergency_incidents_symbology/flammable_gas",
    },
    flammable_liquid: {
        name: "Flammable Liquid",
        url: "nfpa_emergency_incidents_symbology/flammable_liquid",
    },
    flammable_solid: {
        name: "Flammable Solid",
        url: "nfpa_emergency_incidents_symbology/flammable_solid",
    },
    hazardous_incident: {
        name: "Hazardous Incident",
        url: "nfpa_emergency_incidents_symbology/hazardous_incident",
    },
    looting: {
        name: "Looting",
        url: "nfpa_emergency_incidents_symbology/looting",
    },
    marine_accident: {
        name: "Marine Accident",
        url: "nfpa_emergency_incidents_symbology/marine_accident",
    },
    marine_hijacking: {
        name: "Marine Hijacking",
        url: "nfpa_emergency_incidents_symbology/marine_hijacking",
    },
    marine_incident: {
        name: "Marine Incident",
        url: "nfpa_emergency_incidents_symbology/marine_incident",
    },
    non_residential_fire: {
        name: "Non-Residential Fire",
        url: "nfpa_emergency_incidents_symbology/non_residential_fire",
    },
    non_flammable_gas: {
        name: "Non Flammable Gas",
        url: "nfpa_emergency_incidents_symbology/non_flammable_gas",
    },
    organic_peroxides: {
        name: "Organic Peroxides",
        url: "nfpa_emergency_incidents_symbology/organic_peroxides",
    },
    origin: {
        name: "Origin",
        url: "nfpa_emergency_incidents_symbology/origin",
    },
    oxidizers: {
        name: "Oxidizers",
        url: "nfpa_emergency_incidents_symbology/oxidizers",
    },
    poisoning: {
        name: "Poisoning",
        url: "nfpa_emergency_incidents_symbology/poisoning",
    },
    radioactive_material: {
        name: "Radioactive Material",
        url: "nfpa_emergency_incidents_symbology/radioactive_material",
    },
    rail_accident: {
        name: "Rail Accident",
        url: "nfpa_emergency_incidents_symbology/rail_accident",
    },
    rail_hijacking: {
        name: "Rail Hijacking",
        url: "nfpa_emergency_incidents_symbology/rail_hijacking",
    },
    rail_incident: {
        name: "Rail Incident",
        url: "nfpa_emergency_incidents_symbology/rail_incident",
    },
    residential_fire: {
        name: "Residential Fire",
        url: "nfpa_emergency_incidents_symbology/residential_fire",
    },
    school_fire: {
        name: "School Fire",
        url: "nfpa_emergency_incidents_symbology/school_fire",
    },
    shooting: {
        name: "Shooting",
        url: "nfpa_emergency_incidents_symbology/shooting",
    },
    smoke: {
        name: "Smoke",
        url: "nfpa_emergency_incidents_symbology/smoke",
    },
    special_needs_fire: {
        name: "Special Needs Fire",
        url: "nfpa_emergency_incidents_symbology/special_needs_fire",
    },
    spontaneously_combustible: {
        name: "Spontaneously Combustible",
        url: "nfpa_emergency_incidents_symbology/spontaneously_combustible",
    },
    toxic_and_infectious: {
        name: "Toxic And Infectious",
        url: "nfpa_emergency_incidents_symbology/toxic_and_infectious",
    },
    toxic_gas: {
        name: "Toxic Gas",
        url: "nfpa_emergency_incidents_symbology/toxic_gas",
    },
    unexploded_ordnance: {
        name: "Unexploded Ordnance",
        url: "nfpa_emergency_incidents_symbology/unexploded_ordnance",
    },
    vehicle_accident: {
        name: "Vehicle Accident",
        url: "nfpa_emergency_incidents_symbology/vehicle_accident",
    },
    vehicle_hijacking: {
        name: "Vehicle Hijacking",
        url: "nfpa_emergency_incidents_symbology/vehicle_hijacking",
    },
    vehicle_incident: {
        name: "Vehicle Incident",
        url: "nfpa_emergency_incidents_symbology/vehicle_incident",
    },
    wild_fire: {
        name: "Wild Fire",
        url: "nfpa_emergency_incidents_symbology/wild_fire",
    },
}
